import { useLanguage } from '@/context/LanguageContext';
import { translations } from '@/data/translations';
import { Separator } from '@/components/ui/separator';

export default function ImpressumPage() {
  const { t } = useLanguage();

  return (
    <div className="py-12 md:py-24 px-6 md:px-12 lg:px-24" data-testid="impressum-page">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-serif text-4xl md:text-5xl text-[#2C2C2C] tracking-tight mb-12">
          {t(translations.legal.impressumTitle)}
        </h1>

        <div className="space-y-8">
          {/* Owner Section */}
          <section>
            <h2 className="font-serif text-2xl text-[#2C2C2C] mb-4">
              {t(translations.legal.impressum.ownerTitle)}
            </h2>
            <address className="not-italic font-sans text-base text-[#5D5D5D] leading-relaxed space-y-1">
              {t(translations.legal.impressum.owner).map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </address>
          </section>

          <Separator className="bg-[#E5E5E5]" />

          {/* Notice Section */}
          <section>
            <h2 className="font-serif text-2xl text-[#2C2C2C] mb-4">
              {t(translations.legal.impressum.noticeTitle)}
            </h2>
            <p className="font-sans text-base text-[#5D5D5D] leading-relaxed">
              {t(translations.legal.impressum.notice)}
            </p>
          </section>

          <Separator className="bg-[#E5E5E5]" />

          {/* Copyright Section */}
          <section>
            <h2 className="font-serif text-2xl text-[#2C2C2C] mb-4">
              {t(translations.legal.impressum.copyrightTitle)}
            </h2>
            <p className="font-sans text-base text-[#5D5D5D] leading-relaxed">
              {t(translations.legal.impressum.copyright)}
            </p>
          </section>

          <Separator className="bg-[#E5E5E5]" />

          {/* Dispute Resolution */}
          <section>
            <p className="font-sans text-base text-[#5D5D5D] leading-relaxed">
              {t(translations.legal.impressum.dispute)}{' '}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#8B5A2B] hover:underline"
              >
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
